/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PreviousCountSpyContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly commentCounts: {
        readonly totalPublished: number;
    };
    readonly " $refType": "PreviousCountSpyContainer_story";
};
export type PreviousCountSpyContainer_story$data = PreviousCountSpyContainer_story;
export type PreviousCountSpyContainer_story$key = {
    readonly " $data"?: PreviousCountSpyContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"PreviousCountSpyContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PreviousCountSpyContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "CommentCounts",
            "kind": "LinkedField",
            "name": "commentCounts",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalPublished",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '72b0ff8852284ab3b8a7d859b7bc1520';
export default node;
